import React from "react";

export default function OrderButton(props) {

  return <button
    /*onClick={props.onClick}*/
    className='button sucess'>Order</button>;
}
